import React, { useState } from 'react';
import CTooltip from "react-tooltip-lite";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import { shuffle } from 'lodash';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
import ErrorBoundary from 'components/ErrorBoundary';
import DownloadCSVButton from '../DownlaodCSV';




const TopPharmacy = ({ data }) => {
  const [active, setActive] = useState('6');
   const names = [];
  const ammountcount = [];
  const NPI = [];
  const RxCount = [] ;
  const chartData = {
    labels: data.map(({ name, labelToolTip }) => [name, "NPI:" + labelToolTip]),
    datasets: [
      {
        label: 'Dispense Fee Revenue',
        data: data.map(({ value }) => value),
         borderColor: '#702c62',
        backgroundColor: '#702c62',
      },
    ],
  };
 data.forEach(({ name, display}) => {
    names.push(name);
    ammountcount.push(display.replace(/[^0-9.-]+/g, ""));
  });

  data.forEach(({ labelToolTip }) => {
    NPI.push(labelToolTip);
  });


  data.forEach(({ count }) => {
    RxCount.push(count);
  });


  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
     x: {
        ticks: {
          color: "#212121",
          callback: function (value, index, ticks) {
            return "$" + value / 1000 + "k";
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          color: "#212121",
        },
        grid: {
          display: false,
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          title: function (item) {
            const { name, count } =
              data[item[0].dataIndex];
            return `${name}\nRx Count ${count}`;
          },
          label: function (d, t) {
            var xLabel = d.dataset.label;
            var yLabel = '$' + Number(d.formattedValue.replace(/[^0-9.-]+/g, "")).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return xLabel + ': ' + yLabel;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        align: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'end'
            : 'start';
        },
        color: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'black'
            : 'black';
        },
        anchor: 'center',
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 10 },
          value: {
            color: '#2B3346',
          },
        },
        formatter: function (value) {
          return (
            '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          );
        },
      },
    },
  };

  const handleActive = (title) => {
    if (active === title) return;
    const shuffleArry = shuffle(data);
    setActive(title);
    setData(shuffleArry);
  };

  const getDate = () => {
    setActive('custom')
  };

  return (

    <ErrorBoundary>
      <Card className="p-3 h-100 border-1 ">
        <CardHeader className="border-0 bg-white px-0">
          <Row className="align-items-center">
            <Col>
              <CTooltip
                content={
                  <div className="tip-list-info" >
                    <p>
                      Top 10 performing pharmacies based on replenished dispense fee revenue.
                    </p>
                  </div>
                }
              >
                <CardTitle className="f-20 font-weight-600 dashboard-headings mb-0">
                  <div className="d-flex justify-content-between align-items-center top_left_hed pb-1">
                    Top 10 Pharmacies
                    {/* <DownloadCSVButton
                      monthsdata={NPI}
                      valuedata3={names}
                      valuedata1={ammountcount}
                      heading1={["Pharmacy Name", "NPI", "Dispense Fee Revenue"]}
                      filenamedata={"Top10PHs"}
                    /> */}

                       <DownloadCSVButton
                      valuedata3={RxCount}
                      monthsdata={names}
                      valuedata2={ammountcount}
                      valuedata1={NPI}
                      heading1={["Pharmacy Name", "Pharmacy NPI", "Dispense Fee Revenue", "Rx Count"]}
                      filenamedata={"Top10PHs"}
                    />
                    {/* <img src={Download} /> */}
                  </div>
                </CardTitle>
              </CTooltip>
            </Col>
            <Col xs="auto">
              <Nav className="widget-tabs"></Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className="dashboard-chart-body" style={{ padding: "0" }}>
          <div className="dashboard-chart-height chat-container">
            <Bar
              options={options}
              data={chartData}
              plugins={[ChartDataLabels]}
            />
          </div>
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default TopPharmacy;
